import { isNullOrUndefinedOrBlank } from './is-null-or-undefined';

/**
 * Creates a full name based on the object.
 * It should have a firstName and lastName property
 * @param obj
 */
export function fullName(obj: any): string {
  if (isNullOrUndefinedOrBlank(obj)) {
    return '';
  }

  const name = obj.firstName + ' ' + obj.lastName;

  return name.trim();
}
